module.exports = __webpack_public_path__ + "static/media/message-read.ddb847e6.svg";